import { axios, handleError } from '../axios';

export const memberLogout = () => {
  return new Promise((resolve) => {
    axios
      .post('member/account/logout')
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
